import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

const SWIPER_MAIN_CLASS = 'swiper-main';

const InitializeSwiper = uniqueClassMain => {
    const mainClass = `.property-for-sale-card-carousel ${uniqueClassMain ? `.${uniqueClassMain}` : '.swiper-main'}`;
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const mainSwiper = new Swiper(mainClass, {
        spaceBetween: 0,
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });
};

const PrepareCarousel = () => {
    const mcBlocks = document.querySelectorAll('.property-for-sale-card-carousel');

    mcBlocks.forEach((mcBlock, index) => {
        const mainSwiper = mcBlock.querySelector('.swiper-main');
        const mainSwiperWrapper = mainSwiper ? mainSwiper.querySelector('.swiper-main .swiper-wrapper') : null;

        if (mainSwiperWrapper) {
            const swiperSlides = mainSwiperWrapper.querySelectorAll('.swiper-slide');

            if (swiperSlides.length < 2) {
                // less than two slide, hide thumbnail
                mainSwiper?.classList.add('one-slide');
            } else {
                // more than one slide, copy slides to thumbnail carousel
                const uniqueClassMain = `${SWIPER_MAIN_CLASS}-${index}`;
                mainSwiper?.classList.add(uniqueClassMain);

                InitializeSwiper(uniqueClassMain);
            }
        }
    });
};

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', PrepareCarousel);
